import validate from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/middleware/auth.global.js";
import manifest_45route_45rule from "/builds/masterbranch1/smg-lsi/smg-lsi-admin/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}